import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, switchMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionCheckServiceTsService {
  private currentVersion: string | null = null;

  constructor(private http: HttpClient) {}

  startVersionCheck() {
    return interval(300000).pipe(
      switchMap(() =>
        this.http.get<{ version: string }>(`assets/version.json?v=${Date.now()}`)
      ),
      tap((res) => {
        if (!this.currentVersion) {
          this.currentVersion = res.version;
        } else if (this.currentVersion !== res.version) {
          location.reload();
        }
      })
    );
  }
}